import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrameworkEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 283.998,
	height: 284.955,
	viewBox: "0 0 283.998 284.955",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39958",
				"data-name": "Path 39958",
				d: "M0,0H284V284.955H0Z",
				transform: "translate(942 373.684)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-2",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16224",
				"data-name": "Rectangle 16224",
				width: 540.355,
				height: 535.042,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-3",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37718",
				"data-name": "Path 37718",
				d: "M1097.533,1235.814c-53.146,8.538-44.479,126.572,22.117,187.592,35.254,32.3,85.093,48.542,132.4,41.6,63.1-9.264,107.374-118.87-53.622-165.9-25.81-7.54-52.8-63.864-93.692-63.865a45.314,45.314,0,0,0-7.2.58",
				transform: "translate(-1062.947 -1235.234)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient",
			x1: .5,
			x2: .5,
			y2: 1,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#fb6fbb"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#7284fa"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-4",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16226",
				"data-name": "Rectangle 16226",
				width: 339.651,
				height: 331.744,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-5",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37719",
				"data-name": "Path 37719",
				d: "M1088.061,1362.371c-29.92.106-67.584,18.716-108.339,69.6-17.778,22.195-86.5,24.808-96.969,69.151-8.807,37.308,45.691,66.8,107.331,66.859h.311c24.818-.019,50.77-4.813,74.216-15.792,43.3-20.278,77.315-60.163,88.929-106.545,9.435-37.68-18.214-83.089-64.951-83.268Z",
				transform: "translate(-881.814 -1362.371)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-6",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16228",
				"data-name": "Rectangle 16228",
				width: 76.955,
				height: 75.71,
				fill: "#cad0fd"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-7",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37720",
				"data-name": "Path 37720",
				d: "M1351.664,892.242c-4.292.011-6.726,5.079-6.769,11.4v.34a27.4,27.4,0,0,0,5.528,16.336,24.414,24.414,0,0,0,18.438,9.3h.246a10.172,10.172,0,0,0,9.894-9.873v-.164c-.041-4.851-3.712-10.678-14.015-15.616-3.816-1.829-6.51-11.7-13.29-11.724Z",
				transform: "translate(-1344.895 -892.242)",
				fill: "#cad0fd"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-8",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16230",
				"data-name": "Rectangle 16230",
				width: 191.27,
				height: 192.859,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-9",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16229",
				"data-name": "Rectangle 16229",
				width: 191.271,
				height: 192.859,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-10",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37722",
				"data-name": "Path 37722",
				d: "M1736.891,1363.327l-9.234,168.6a8.981,8.981,0,0,0,8.27,9.632l106.269,5.821,1.954.108a8.98,8.98,0,0,0,9.272-8.671v-.006l3.411-62.275,2.328-42.508,7.252.4a8.98,8.98,0,0,0,9.273-8.671l2.337-42.666a8.981,8.981,0,0,0-8.27-9.633l-7.252-.4.155-2.843a8.98,8.98,0,0,0-8.27-9.632l-3.539-.194-104.682-5.735c-.157-.009-.313-.013-.469-.013a9,9,0,0,0-8.8,8.684",
				transform: "translate(-1727.642 -1354.643)",
				fill: "#7284fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-11",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16235",
				"data-name": "Rectangle 16235",
				width: 370.346,
				height: 369.111,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-12",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16234",
				"data-name": "Rectangle 16234",
				width: 129.191,
				height: 192.739,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-13",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16233",
				"data-name": "Rectangle 16233",
				width: 129.19,
				height: 192.739,
				fill: "#5d6ee1"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-14",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37724",
				"data-name": "Path 37724",
				d: "M2485.466,1643.16l20.837,1.243,6.445.384.351-5.83,3.752-62.271,6.38-105.9-5.919-.353-21.469-1.281Z",
				transform: "translate(-2485.466 -1469.152)",
				fill: "#cfe4fc"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-16",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16238",
				"data-name": "Rectangle 16238",
				width: 33.299,
				height: 175.251,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-17",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16237",
				"data-name": "Rectangle 16237",
				width: 33.298,
				height: 175.251,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-18",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37726",
				"data-name": "Path 37726",
				d: "M1558.448,1314.767l-10.431,172.2a9.364,9.364,0,0,0,8.78,9.913l115.313,6.985a9.364,9.364,0,0,0,9.913-8.781l.176-2.9,7.728.468a9.363,9.363,0,0,0,9.913-8.78l2.64-43.576a9.363,9.363,0,0,0-8.78-9.913l-7.727-.468,6.483-107.026a9.363,9.363,0,0,0-8.78-9.913l-115.313-6.985c-.193-.012-.385-.017-.575-.017a9.363,9.363,0,0,0-9.338,8.8",
				transform: "translate(-1548 -1305.969)",
				fill: "#7284fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-19",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37728",
				"data-name": "Path 37728",
				d: "M2860.824,1614.125l4.019.24,2.549-42.466-4.035-.241Z",
				transform: "translate(-2860.824 -1571.658)",
				fill: "#cfe4fc"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-21",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16241",
				"data-name": "Rectangle 16241",
				width: 122.95,
				height: 178.007,
				fill: "#3b4bb5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-22",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37730",
				"data-name": "Path 37730",
				d: "M1564.969,1378.622l-1.875,169.165,97.485,1.081,23.038.255,2.428-176.666-15.946-.176-14.9-.166-90.144-1Z",
				transform: "translate(-1563.094 -1371.117)",
				fill: "#dbecff"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-24",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16244",
				"data-name": "Rectangle 16244",
				width: 119.159,
				height: 177.822,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-25",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37732",
				"data-name": "Path 37732",
				d: "M1396.526,1383.861l19.466,175.606,119.8-13.279-19-175.658Z",
				transform: "translate(-1396.526 -1370.53)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-2",
			x1: -.554,
			y1: 1.661,
			x2: -.553,
			y2: 1.661,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#fff"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#f8feff"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-26",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37734",
				"data-name": "Path 37734",
				d: "M1609.868,2156.707l-4.339-2.76-1.177,1.851,6.065,3.857,9.155-12.391-1.764-1.3Z",
				transform: "translate(-1604.352 -2145.961)",
				fill: "#7dd3c2"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-27",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37736",
				"data-name": "Path 37736",
				d: "M1636.71,2401.07l-4.339-2.76-1.177,1.851,6.065,3.857,9.155-12.391-1.764-1.3Z",
				transform: "translate(-1631.194 -2390.325)",
				fill: "#7dd3c2"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-framework-28",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16803",
				"data-name": "Rectangle 16803",
				width: 104.981,
				height: 94.968,
				fill: "none"
			})
		})
	] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_6",
		"data-name": "Mask Group 6",
		transform: "translate(-942 -373.684)",
		clipPath: "url(#clip-path-framework)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_15650",
			"data-name": "Group 15650",
			transform: "translate(1)",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "Group_15368",
				"data-name": "Group 15368",
				transform: "translate(837.859 269.35)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group_14026",
					"data-name": "Group 14026",
					children: [
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12893",
							"data-name": "Group 12893",
							transform: "translate(60.468 62.438)",
							children: /* @__PURE__ */ _jsxs("g", {
								id: "Group_15651",
								"data-name": "Group 15651",
								children: [
									/* @__PURE__ */ _jsx("g", {
										id: "Group_12876",
										"data-name": "Group 12876",
										transform: "translate(-60.468 -62.438)",
										opacity: .31,
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12875",
											"data-name": "Group 12875",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_12874",
												"data-name": "Group 12874",
												clipPath: "url(#clip-path-framework-2)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_12873",
													"data-name": "Group 12873",
													transform: "translate(131.219 152.488)",
													children: /* @__PURE__ */ _jsx("g", {
														id: "Group_12872",
														"data-name": "Group 12872",
														clipPath: "url(#clip-path-framework-3)",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_16223",
															"data-name": "Rectangle 16223",
															width: 372.185,
															height: 393.511,
															transform: "matrix(0.558, -0.83, 0.83, 0.558, -128.142, 163.079)",
															fill: "url(#linear-gradient)"
														})
													})
												})
											})
										})
									}),
									/* @__PURE__ */ _jsx("g", {
										id: "Group_12881",
										"data-name": "Group 12881",
										transform: "translate(16.459 23.276)",
										opacity: .31,
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12880",
											"data-name": "Group 12880",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_12879",
												"data-name": "Group 12879",
												clipPath: "url(#clip-path-framework-4)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_12878",
													"data-name": "Group 12878",
													transform: "translate(31.931 82.469)",
													children: /* @__PURE__ */ _jsx("g", {
														id: "Group_12877",
														"data-name": "Group 12877",
														clipPath: "url(#clip-path-framework-5)",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_16225",
															"data-name": "Rectangle 16225",
															width: 302.9,
															height: 225.613,
															transform: "translate(-22.433 1.037) rotate(-4.072)",
															fill: "#7284fa"
														})
													})
												})
											})
										})
									}),
									/* @__PURE__ */ _jsx("g", {
										id: "Group_12886",
										"data-name": "Group 12886",
										transform: "translate(86.989 28.608)",
										opacity: .31,
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12885",
											"data-name": "Group 12885",
											transform: "translate(0)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_12884",
												"data-name": "Group 12884",
												clipPath: "url(#clip-path-framework-6)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_12883",
													"data-name": "Group 12883",
													transform: "translate(18.569 19.1)",
													children: /* @__PURE__ */ _jsx("g", {
														id: "Group_12882",
														"data-name": "Group 12882",
														clipPath: "url(#clip-path-framework-7)",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_16227",
															"data-name": "Rectangle 16227",
															width: 49.144,
															height: 47.838,
															transform: "matrix(0.479, -0.878, 0.878, 0.479, -15.71, 28.812)",
															fill: "#cad0fd"
														})
													})
												})
											})
										})
									}),
									/* @__PURE__ */ _jsx("g", {
										id: "Group_12891",
										"data-name": "Group 12891",
										transform: "translate(114.889 106.419)",
										opacity: .271,
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12890",
											"data-name": "Group 12890",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_12889",
												"data-name": "Group 12889",
												clipPath: "url(#clip-path-framework-8)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_12888",
													"data-name": "Group 12888",
													transform: "translate(-0.001 0)",
													children: /* @__PURE__ */ _jsx("g", {
														id: "Group_12887",
														"data-name": "Group 12887",
														clipPath: "url(#clip-path-framework-9)",
														children: /* @__PURE__ */ _jsx("path", {
															id: "Path_37721",
															"data-name": "Path 37721",
															d: "M1611.742,1396.28l-2.337,42.666a8.98,8.98,0,0,1-9.273,8.671l-7.253-.4-2.327,42.508L1587.142,1552v.006a8.98,8.98,0,0,1-9.272,8.671l-1.954-.107-102.113-5.593-33.851,3.753-19.465-175.606,22.4-2.484.036-3.27.083-7.5,30.507.337a8.582,8.582,0,0,1,6.37-2.358l52.5,2.875-1.1.122,1.869.021,2.306.026-3.075-.169,8.369-.927.125,1.157,7.178.08,15.947.175-.017,1.247,20.583,1.127,3.539.194a8.979,8.979,0,0,1,8.27,9.631l-.154,2.843,7.251.4a8.982,8.982,0,0,1,8.271,9.633",
															transform: "translate(-1420.486 -1367.835)",
															fill: "#631480"
														})
													})
												})
											})
										})
									})
								]
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12895",
							"data-name": "Group 12895",
							transform: "translate(213.275 167.229)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12894",
								"data-name": "Group 12894",
								clipPath: "url(#clip-path-framework-10)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16232",
									"data-name": "Rectangle 16232",
									width: 193.912,
									height: 224.386,
									transform: "matrix(0.969, -0.247, 0.247, 0.969, -46.45, 11.764)",
									fill: "#7284fa"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12902",
							"data-name": "Group 12902",
							transform: "translate(60.468 62.438)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12901",
								"data-name": "Group 12901",
								clipPath: "url(#clip-path-framework-11)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_12900",
									"data-name": "Group 12900",
									transform: "translate(150.466 104.684)",
									opacity: .439,
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_12899",
										"data-name": "Group 12899",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12898",
											"data-name": "Group 12898",
											clipPath: "url(#clip-path-framework-12)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_12897",
												"data-name": "Group 12897",
												transform: "translate(0 0)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_12896",
													"data-name": "Group 12896",
													clipPath: "url(#clip-path-framework-13)",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_37723",
														"data-name": "Path 37723",
														d: "M1837.877,1475.676l-3.411,62.276c-.166,0-.332-.005-.5-.016l-7.728-.468-.175,2.9a9.326,9.326,0,0,1-2.824,6.152l-106.269-5.821a8.981,8.981,0,0,1-8.27-9.632l9.234-168.6a8.98,8.98,0,0,1,9.273-8.671l104.682,5.735a9.359,9.359,0,0,1,4.6,8.642l-6.483,107.026,7.727.468.138.011",
														transform: "translate(-1708.687 -1353.782)",
														fill: "#5d6ee1"
													})
												})
											})
										})
									})
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12904",
							"data-name": "Group 12904",
							transform: "translate(306.827 181.365)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12903",
								"data-name": "Group 12903",
								clipPath: "url(#clip-path-framework-14)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16236",
									"data-name": "Rectangle 16236",
									width: 132.47,
									height: 165.075,
									transform: "matrix(0.815, -0.579, 0.579, 0.815, -82.906, 58.861)",
									fill: "#cfe4fc"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12911",
							"data-name": "Group 12911",
							transform: "translate(60.468 62.438)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12910",
								"data-name": "Group 12910",
								clipPath: "url(#clip-path-framework-11)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_12909",
									"data-name": "Group 12909",
									transform: "translate(246.358 118.926)",
									opacity: .259,
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_12908",
										"data-name": "Group 12908",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12907",
											"data-name": "Group 12907",
											clipPath: "url(#clip-path-framework-16)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_12906",
												"data-name": "Group 12906",
												transform: "translate(0.001 0)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_12905",
													"data-name": "Group 12905",
													clipPath: "url(#clip-path-framework-17)",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_37725",
														"data-name": "Path 37725",
														d: "M2518.764,1576.8l-3.411,62.276c-.166,0-.332-.005-.5-.016l-1.755-.106-5.973-.362-.175,2.9a9.32,9.32,0,0,1-.648,2.906l-20.837-1.244,10.377-174.007,21.469,1.281-6.413,105.892,5.953.36,1.774.108.138.01",
														transform: "translate(-2485.466 -1469.152)",
														fill: "#326f7d"
													})
												})
											})
										})
									})
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12913",
							"data-name": "Group 12913",
							transform: "translate(191.098 161.22)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12912",
								"data-name": "Group 12912",
								clipPath: "url(#clip-path-framework-18)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16240",
									"data-name": "Rectangle 16240",
									width: 226.59,
									height: 246.281,
									transform: "matrix(0.898, -0.441, 0.441, 0.898, -78.733, 38.531)",
									fill: "#7284fa"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12915",
							"data-name": "Group 12915",
							transform: "translate(353.165 194.019)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12914",
								"data-name": "Group 12914",
								clipPath: "url(#clip-path-framework-19)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_37727",
									"data-name": "Path 37727",
									d: "M2849.2,1420.039l2.289,59.284,7.147-27.695-2.289-59.284Z",
									transform: "translate(-2850.638 -1414.481)",
									fill: "#cfe4fc"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12920",
							"data-name": "Group 12920",
							transform: "translate(60.468 62.438)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12919",
								"data-name": "Group 12919",
								clipPath: "url(#clip-path-framework-11)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_12918",
									"data-name": "Group 12918",
									transform: "translate(135.465 109.944)",
									opacity: .369,
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_12917",
										"data-name": "Group 12917",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12916",
											"data-name": "Group 12916",
											clipPath: "url(#clip-path-framework-21)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_37729",
												"data-name": "Path 37729",
												d: "M1587.164,1573.006v.06l120.522,1.336,2.428-176.665-120.993-1.341Z",
												transform: "translate(-1587.164 -1396.395)",
												fill: "#3b4bb5"
											})
										})
									})
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12922",
							"data-name": "Group 12922",
							transform: "translate(192.962 169.262)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12921",
								"data-name": "Group 12921",
								clipPath: "url(#clip-path-framework-22)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16243",
									"data-name": "Rectangle 16243",
									width: 205.017,
									height: 216.193,
									transform: "matrix(0.801, -0.598, 0.598, 0.801, -85.335, 63.717)",
									fill: "#dbecff"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12927",
							"data-name": "Group 12927",
							transform: "translate(60.468 62.438)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12926",
								"data-name": "Group 12926",
								clipPath: "url(#clip-path-framework-11)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_12925",
									"data-name": "Group 12925",
									transform: "translate(132.493 106.754)",
									opacity: .329,
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_12924",
										"data-name": "Group 12924",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_12923",
											"data-name": "Group 12923",
											clipPath: "url(#clip-path-framework-24)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_37731",
												"data-name": "Path 37731",
												d: "M1670.013,1370.551l-14.817,1.068-90.227,6.507-1.875,169.165,97.475,1.081h.012l21.671-1.563v-.008L1670.1,1371.785Z",
												transform: "translate(-1563.094 -1370.551)",
												fill: "#a8a8a8"
											})
										})
									})
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12929",
							"data-name": "Group 12929",
							transform: "translate(172.399 169.19)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12928",
								"data-name": "Group 12928",
								clipPath: "url(#clip-path-framework-25)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16246",
									"data-name": "Rectangle 16246",
									width: 229.664,
									height: 233.709,
									transform: "translate(-93.842 83.608) rotate(-41.699)",
									fill: "url(#linear-gradient-2)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16247",
							"data-name": "Rectangle 16247",
							width: 92.742,
							height: 1.757,
							transform: "translate(193.935 227.477) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16248",
							"data-name": "Rectangle 16248",
							width: 62.75,
							height: 1.757,
							transform: "translate(205.229 210.432) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16249",
							"data-name": "Rectangle 16249",
							width: 93.647,
							height: 1.757,
							transform: "translate(194.613 233.59) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16250",
							"data-name": "Rectangle 16250",
							width: 93.861,
							height: 1.757,
							transform: "translate(195.078 239.727) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16251",
							"data-name": "Rectangle 16251",
							width: 93.861,
							height: 1.757,
							transform: "translate(195.835 245.587) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16252",
							"data-name": "Rectangle 16252",
							width: 67.217,
							height: 1.757,
							transform: "translate(195.835 252.514) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16253",
							"data-name": "Rectangle 16253",
							width: 32.97,
							height: 1.757,
							transform: "translate(215.174 267.017) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16254",
							"data-name": "Rectangle 16254",
							width: 78.524,
							height: 1.757,
							transform: "translate(215.852 273.129) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16255",
							"data-name": "Rectangle 16255",
							width: 78.703,
							height: 1.757,
							transform: "translate(216.351 279.262) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16256",
							"data-name": "Rectangle 16256",
							width: 32.97,
							height: 1.757,
							transform: "translate(217.852 296.571) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16257",
							"data-name": "Rectangle 16257",
							width: 78.524,
							height: 1.757,
							transform: "translate(218.53 302.683) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_16258",
							"data-name": "Rectangle 16258",
							width: 78.703,
							height: 1.757,
							transform: "translate(219.029 308.816) rotate(-6.325)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_37733",
							"data-name": "Path 37733",
							d: "M1587.855,2165.019l1.465,14.03,14.861-1.552-1.465-14.03Zm14.306,10.935-11.185,1.168-1.1-10.56,11.185-1.168Z",
							transform: "translate(-1391.837 -1896.391)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12931",
							"data-name": "Group 12931",
							transform: "translate(198.055 264.916)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12930",
								"data-name": "Group 12930",
								clipPath: "url(#clip-path-framework-26)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16259",
									"data-name": "Rectangle 16259",
									width: 18.196,
									height: 17.108,
									transform: "translate(-3.361 0.881) rotate(-14.697)",
									fill: "#7dd3c2"
								})
							})
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_37735",
							"data-name": "Path 37735",
							d: "M1614.7,2409.383l1.465,14.03,14.861-1.551-1.465-14.03Zm14.306,10.935-11.185,1.168-1.1-10.561,11.185-1.167Z",
							transform: "translate(-1415.367 -2110.589)",
							fill: "#474bac"
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_12933",
							"data-name": "Group 12933",
							transform: "translate(201.369 295.082)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_12932",
								"data-name": "Group 12932",
								clipPath: "url(#clip-path-framework-27)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16260",
									"data-name": "Rectangle 16260",
									width: 18.196,
									height: 17.108,
									transform: "translate(-3.361 0.881) rotate(-14.697)",
									fill: "#7dd3c2"
								})
							})
						})
					]
				})
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_15369",
				"data-name": "Group 15369",
				transform: "translate(331.746 161.066)",
				children: [/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse_241",
					"data-name": "Ellipse 241",
					cx: 45.091,
					cy: 45.091,
					r: 45.091,
					transform: "translate(723.154 397.139)",
					fill: "#fff"
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_14022",
					"data-name": "Group 14022",
					transform: "translate(715.754 394.746)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_14021",
						"data-name": "Group 14021",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_14020",
							"data-name": "Group 14020",
							clipPath: "url(#clip-path-framework-28)",
							children: [
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14014",
									"data-name": "Group 14014",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "Group_14013",
										"data-name": "Group 14013",
										clipPath: "url(#clip-path-framework-28)",
										children: [
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39093",
												"data-name": "Path 39093",
												d: "M57.064,0a47.484,47.484,0,1,0,47.484,47.484A47.484,47.484,0,0,0,57.064,0m0,91.651a44.167,44.167,0,1,1,44.167-44.167A44.167,44.167,0,0,1,57.064,91.652",
												transform: "translate(-4.574 0)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39094",
												"data-name": "Path 39094",
												d: "M61.959,12.007A40.372,40.372,0,1,1,21.586,52.379,40.417,40.417,0,0,1,61.959,12.007m0-1.754a42.126,42.126,0,1,0,42.126,42.126A42.126,42.126,0,0,0,61.959,10.253",
												transform: "translate(-9.469 -4.895)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_535",
												"data-name": "Line 535",
												y2: 24.999,
												transform: "translate(52.49 22.438)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_536",
												"data-name": "Line 536",
												x1: 6.47,
												y2: 24.147,
												transform: "translate(52.491 23.29)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_537",
												"data-name": "Line 537",
												x1: 12.5,
												y2: 21.65,
												transform: "translate(52.49 25.787)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_538",
												"data-name": "Line 538",
												x1: 17.677,
												y2: 17.677,
												transform: "translate(52.491 29.76)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_539",
												"data-name": "Line 539",
												x1: 24.147,
												y2: 6.47,
												transform: "translate(52.49 40.967)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_540",
												"data-name": "Line 540",
												x1: 24.999,
												transform: "translate(52.49 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_541",
												"data-name": "Line 541",
												x1: 24.147,
												y1: 6.47,
												transform: "translate(52.49 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_542",
												"data-name": "Line 542",
												x1: 21.65,
												y1: 12.5,
												transform: "translate(52.49 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_543",
												"data-name": "Line 543",
												x1: 17.677,
												y1: 17.677,
												transform: "translate(52.491 47.438)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_544",
												"data-name": "Line 544",
												x1: 12.5,
												y1: 21.65,
												transform: "translate(52.49 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_545",
												"data-name": "Line 545",
												x1: 6.47,
												y1: 24.147,
												transform: "translate(52.491 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_546",
												"data-name": "Line 546",
												y1: 24.999,
												transform: "translate(52.49 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_547",
												"data-name": "Line 547",
												y1: 24.147,
												x2: 6.47,
												transform: "translate(46.02 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_548",
												"data-name": "Line 548",
												y1: 21.65,
												x2: 12.5,
												transform: "translate(39.991 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_549",
												"data-name": "Line 549",
												y1: 17.677,
												x2: 17.677,
												transform: "translate(34.813 47.438)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_550",
												"data-name": "Line 550",
												y1: 12.5,
												x2: 21.65,
												transform: "translate(30.84 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_551",
												"data-name": "Line 551",
												y1: 6.47,
												x2: 24.147,
												transform: "translate(28.343 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_552",
												"data-name": "Line 552",
												x2: 24.999,
												transform: "translate(27.491 47.437)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_553",
												"data-name": "Line 553",
												x2: 24.147,
												y2: 6.47,
												transform: "translate(28.343 40.967)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_554",
												"data-name": "Line 554",
												x2: 21.65,
												y2: 12.5,
												transform: "translate(30.84 34.938)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_555",
												"data-name": "Line 555",
												x2: 17.677,
												y2: 17.677,
												transform: "translate(34.813 29.76)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_556",
												"data-name": "Line 556",
												x2: 12.5,
												y2: 21.65,
												transform: "translate(39.991 25.787)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_557",
												"data-name": "Line 557",
												x2: 6.47,
												y2: 24.147,
												transform: "translate(46.02 23.29)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("line", {
												id: "Line_558",
												"data-name": "Line 558",
												x1: 21.65,
												y2: 12.5,
												transform: "translate(52.49 34.938)",
												fill: "none",
												stroke: "#103b7a",
												strokeMiterlimit: 10,
												strokeWidth: 3.356
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39095",
												"data-name": "Path 39095",
												d: "M76.761,93.105a25.923,25.923,0,1,1,25.923-25.923A25.953,25.953,0,0,1,76.761,93.105m0-50.093a24.169,24.169,0,1,0,24.169,24.169A24.2,24.2,0,0,0,76.761,43.013",
												transform: "translate(-24.271 -19.698)",
												fill: "#103b7a"
											})
										]
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "C",
									transform: "translate(25.431 29.388) rotate(-49.036)",
									fill: "#103b7a",
									fontSize: 7,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "C"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "E",
									transform: "translate(31.493 21.606) rotate(-34.323)",
									fill: "#103b7a",
									fontSize: 6,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "E"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "R",
									transform: "matrix(0.934, -0.358, 0.358, 0.934, 38.129, 18.544)",
									fill: "#103b7a",
									fontSize: 7,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "R"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "T",
									transform: "translate(45.578 14.973) rotate(-7.335)",
									fill: "#103b7a",
									fontSize: 6,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "T"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "I",
									transform: "translate(53.15 13.349) rotate(3.062)",
									fill: "#103b7a",
									fontSize: 5,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "I"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "F",
									transform: "matrix(0.973, 0.232, -0.232, 0.973, 57.873, 14.698)",
									fill: "#103b7a",
									fontSize: 6,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "F"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "I-2",
									"data-name": "I",
									transform: "matrix(0.915, 0.404, -0.404, 0.915, 65.343, 15.805)",
									fill: "#103b7a",
									fontSize: 5,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "I"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "E-2",
									"data-name": "E",
									transform: "matrix(0.828, 0.56, -0.56, 0.828, 69.259, 18.731)",
									fill: "#103b7a",
									fontSize: 6,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "E"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "D",
									transform: "matrix(0.663, 0.748, -0.748, 0.663, 74.614, 23.758)",
									fill: "#103b7a",
									fontSize: 7,
									fontFamily: "Poppins-Medium, Poppins",
									fontWeight: 500,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "D"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14016",
									"data-name": "Group 14016",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "Group_14015",
										"data-name": "Group 14015",
										clipPath: "url(#clip-path-framework-28)",
										children: [
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39096",
												"data-name": "Path 39096",
												d: "M3.733,91.573l4.381-8.194L3.733,75.185H104.812l-4.381,8.194,4.381,8.194Z",
												transform: "translate(-1.782 -35.895)",
												fill: "#fff"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39097",
												"data-name": "Path 39097",
												d: "M101.079,75.286l-3.167,5.922-.589,1.1.589,1.1,3.167,5.922H3.9l3.167-5.922.589-1.1-.589-1.1L3.9,75.286Zm3.9-2.338H0l5.006,9.363L0,91.674H104.981l-5.006-9.363Z",
												transform: "translate(0 -34.827)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39098",
												"data-name": "Path 39098",
												d: "M102.088,70.451,100.733,74.6l.45,4.342-2.926,3.239L96.9,86.331,92.912,88.1,89.986,91.34l-4.365-.006L81.631,93.1l-3.985-1.781-4.365-.007-2.916-3.248L66.38,86.286l-1.343-4.153-2.916-3.248.463-4.341L61.241,70.39l2.188-3.777.463-4.341,3.535-2.56,2.188-3.777,4.271-.9,3.535-2.561,4.268.914,4.271-.9,3.527,2.571,4.268.914,2.177,3.783,3.528,2.571.449,4.342Z",
												transform: "translate(-29.238 -25.052)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39099",
												"data-name": "Path 39099",
												d: "M101.792,73.2l-1.173,3.591.389,3.757-2.532,2.8L97.3,86.943l-3.453,1.532-2.532,2.8-3.777-.006L84.089,92.8l-3.449-1.541-3.777-.006L74.34,88.446,70.891,86.9,69.73,83.31,67.206,80.5l.4-3.756-1.162-3.594,1.894-3.268.4-3.756L71.8,63.908l1.894-3.268,3.7-.78,3.059-2.216,3.694.791,3.7-.78,3.052,2.225,3.694.791,1.884,3.274,3.052,2.225.389,3.757Z",
												transform: "translate(-31.722 -27.521)",
												fill: "#fff"
											})
										]
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "_0",
									"data-name": 0,
									transform: "translate(29.227 72.719) rotate(37.82)",
									fill: "#103b7a",
									fontSize: 7,
									fontFamily: "Montserrat-ExtraBold, Montserrat",
									fontWeight: 800,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "0"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "_0-2",
									"data-name": 0,
									transform: "translate(38.921 77.938) rotate(18.697)",
									fill: "#103b7a",
									fontSize: 6,
									fontFamily: "Montserrat-ExtraBold, Montserrat",
									fontWeight: 800,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "0"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "_0-3",
									"data-name": 0,
									transform: "translate(49.624 81.701) rotate(-0.933)",
									fill: "#103b7a",
									fontSize: 7,
									fontFamily: "Montserrat-ExtraBold, Montserrat",
									fontWeight: 800,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "0"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "_0-4",
									"data-name": 0,
									transform: "translate(61.67 80.536) rotate(-21.291)",
									fill: "#103b7a",
									fontSize: 7,
									fontFamily: "Montserrat-ExtraBold, Montserrat",
									fontWeight: 800,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "0"
									})
								}),
								/* @__PURE__ */ _jsx("text", {
									id: "_1",
									"data-name": 1,
									transform: "translate(71.719 74.492) rotate(-38.971)",
									fill: "#103b7a",
									fontSize: 6,
									fontFamily: "Montserrat-ExtraBold, Montserrat",
									fontWeight: 800,
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "1"
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14019",
									"data-name": "Group 14019",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "Group_14018",
										"data-name": "Group 14018",
										clipPath: "url(#clip-path-framework-28)",
										children: [
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39100",
												"data-name": "Path 39100",
												d: "M23.113,83.237l1.044,3.212h3.378L24.8,88.435l1.044,3.213-2.733-1.986L20.38,91.648l1.044-3.213L18.691,86.45h3.378Z",
												transform: "translate(-8.924 -39.739)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39101",
												"data-name": "Path 39101",
												d: "M44.058,83.237,45.1,86.45H48.48l-2.733,1.985,1.044,3.213-2.733-1.986-2.733,1.986,1.044-3.213L39.637,86.45h3.378Z",
												transform: "translate(-18.923 -39.739)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39102",
												"data-name": "Path 39102",
												d: "M148.392,83.237l1.044,3.212h3.378l-2.733,1.985,1.044,3.213-2.733-1.986-2.733,1.986,1.044-3.213-2.733-1.985h3.378Z",
												transform: "translate(-68.734 -39.739)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39103",
												"data-name": "Path 39103",
												d: "M169.338,83.237l1.044,3.212h3.378l-2.733,1.985,1.044,3.213-2.733-1.986-2.733,1.986,1.044-3.213-2.733-1.985h3.378Z",
												transform: "translate(-78.734 -39.739)",
												fill: "#103b7a"
											}),
											/* @__PURE__ */ _jsx("path", {
												id: "Path_39106",
												"data-name": "Path 39106",
												d: "M153.909,83.237l2.346,7.22h7.592L157.7,94.919l2.346,7.221-6.142-4.463-6.142,4.463,2.346-7.221-6.142-4.462h7.592Z",
												transform: "translate(-101.734 -46.231)",
												fill: "none",
												stroke: "#113b7a",
												strokeWidth: 2
											})
										]
									})
								})
							]
						})
					})
				})]
			})]
		})
	})]
});
export default SvgFrameworkEmptyState;
